<template>
    <div>
        <v-card-text>
            <v-form @submit.prevent="saveFamilyInterview" ref="form" :disabled="disableForm">
                <v-container style="
                    border: solid 1px #e1e3e2;
                    border-radius: 15px;
                    padding: 15px;
                    ">
                    <v-row dense>
                        <v-col class="d-flex" cols="12" sm="4">
                            <v-radio-group v-model="family_interview" :rules="formRules">
                                <p>{{ $t('inputs.family_interview.family_interview_question') }}<span style="color: red">*</span></p>

                                <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>

                                <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="8" v-if="hasNotInterview">
                            <v-autocomplete :items="reasons" item-text="description" item-value="id" variant="outlined"
                                :rules="formRules" color="#086318" v-model="resource.reason_interview_id">
                                <template v-slot:label>
                                    {{ $t('descriptions.choose_a_reason') }} <span style="color: red">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row dense class="form-actions">
                        <v-btn
                            class="rounded-lg form-action-btn"
                            elevation="0"
                            color="#41916b"
                            type="submit"
                            :loading="loading"
                        >
                            <span class="textBtn">{{ titleBTN }}</span>
                        </v-btn>

                        <v-btn
                            class="form-edit-btn"
                            v-if="disableEditButton"
                            color="#41916b"
                            fab
                            small
                            dark
                            @click="(disableForm = false), (disableSaveButton = false)"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>

                        <BackToGridBtn />
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>
    </div>
</template>
<script>
import axios from "@/axios";
import { mapActions, mapGetters } from "vuex";
import currentUser from "@/utils/currentUser";
import { getReasonNotFamilyInterviewList } from "@/service/basic-registrations/ReasonNotFamilyInterviewService";
import FormFieldsService from "@/service/FormFieldsService";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
    data() {
        return {
            tab: 1,
            loading: false,
            disableForm: false,
            disableSaveButton: true,
            disableEditButton: false,
            formRules: [(v) => !!v || this.$t('messages.required_field')],
            resource: {},
            family_interview: null,
            reasons: [],
            patientTypes: [],
        };
    },

    components: {
        BackToGridBtn
    },

    computed: {
        ...mapGetters({
            patientData: "getPatientData",
        }),
        currentUser() {
            return currentUser.getUserData()
        },

        hasNotInterview() {
            return this.family_interview == 'NÃO';
        },

        titleBTN() {
            return this.resource.id ? this.$t('buttons.to_update') : this.$t('buttons.save');
        },
    },

    mounted() {
        this.getReasons();
        this.fillForm();
    },

    methods: {
        ...mapActions(["changeSnackBarData"]),

        fillForm() {
            this.checkTab();
            const family_interview = 
            this.patientData.family_interviews 
            ? this.patientData.family_interviews[0] 
            : null;

            if (family_interview) {
                this.resource = family_interview;
                this.resource.reason_interview_id = parseInt(family_interview.reason_interview_id);
                this.family_interview = family_interview.there_was_an_interview;
            }
        },

        async getReasons() { 
            this.patientTypes = await FormFieldsService.getKindOfDonor(); 
            this.reasons = await getReasonNotFamilyInterviewList({ kind_of_donor: this.getPatientTypeDescription() });
        },

        getPatientTypeDescription() {
            const patientType = this.patientTypes.find((type) => type.id == this.patientData.kind_of_donor_id); 

            return patientType ? patientType.name : null;
        },

        saveFamilyInterview() {
            if (this.$refs.form.validate()) {
                this.loading = true; 

                const family_authorization_id = this.resource.id ?? null;

                const data = {
                    user_id: this.currentUser.id,
                    donor_id: this.patientData.id,
                    there_was_an_interview: this.family_interview,
                    reason_interview_id: this.resource.reason_interview_id ?? null,
                    justification: null
                };

                axios({
                    method: family_authorization_id ? "PUT" : "POST",
                    url: family_authorization_id
                        ? `/family_interviews/${family_authorization_id}`
                        : `/family_interviews`,
                    data,
                }).then((response) => {
                    this.loading = false;

                    this.changeSnackBarData({
                        status: true,
                        type: "success",
                        titleMessage: response.data.message,
                        bodyMessage: "",
                        cardColor: "success",
                        titleIcon: "mdi-check-circle",
                    });

                    this.redirect();
                    setTimeout(() =>
                        this.closeSnackBar(), 3000);
                }).catch((error) => {
                    this.loading = false;

                    this.changeSnackBarData({
                        status: true,
                        type: "erro",
                        titleMessage: this.$t('messages.something_went_wrong'),
                        bodyMessage: error.details ?? '',
                        cardColor: "red",
                        titleIcon: "mdi-close-circle",
                    });

                    setTimeout(() => this.closeSnackBar(), 3000);
                });
            }
        },

        redirect() {
            switch (this.family_interview) {
                case "SIM":
                    this.$emit('changeTab', 1)
                    break;
                case "NÃO":
                    this.$router.push("/pacientes");
                    break;
                default:
                    this.$router.push("/pacientes");
            }
        },

        closeSnackBar() {
            this.changeSnackBarData({
                status: false,
                type: "",
                titleMessage: "",
                bodyMessage: "",
                cardColor: "",
                titleIcon: "",
            });
        },

        checkTab() {
            if (!this.patientData.family_authorization?.length 
            && this.patientData.family_interviews?.length) 
            {
                this.$emit('changeTab', 1)
            }
        },
    }
}
</script>
<style scoped>
.form-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}

.form-action-btn,
.form-edit-btn {
  margin-right: 4px;
}

.form-action-btn:last-child {
  margin-right: 0;
}

.textBtn {
  color: #fff;
}

@media (max-width: 768px) {
  .form-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .form-action-btn,
  .form-edit-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .form-edit-btn {
    border-radius: 8px !important;
  }

  .form-action-btn:last-child,
  .form-edit-btn:last-child {
    margin-bottom: 0;
  }
}
</style>
